var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixalerts"},[_c('div',{staticClass:"u-alert-center",class:{'show': _vm.center}},[_vm._v(_vm._s(_vm.centerMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }